export const ORDER_HISTORY_SOURCE_PAGE = 'orderHistory';
export const BUY_IT_AGAIN_SOURCE_PAGE = 'buyItAgain';

export const ORDER_HISTORY_PAGE_NAME = 'My Account:Order History';
export const BUY_IT_AGAIN_PAGE_NAME = 'My Account:Buy It Again';
